import { CompType, expected, randomUUID } from '@aloft/toolkit-shared';
import { Text } from '@react-pdf/renderer';

import { getCommentaryTableHelperText } from '../../../redux/features/selectors/utils/getCommentaryTableHelperText.ts';
import { COMMENTARY_TEXT } from '../../commentary/consts.ts';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { Table } from '../components/Table.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { ListToSalePageProps } from '../types.ts';

export const ListToSalePage = ({
  subjectAddress,
  adjustmentSettings,
  adjustmentsTableData,
  compSequence,
  compTypes,
}: ListToSalePageProps) => {
  const listToSaleTableData = adjustmentsTableData.listToSale;
  if (!listToSaleTableData) return null;

  const { commentary, method, ratio, tableData } = listToSaleTableData;
  if (method === 'none') return null;

  const { title, subtitle, headerText } = COMMENTARY_TEXT['list-to-sale'];
  const helperText = getCommentaryTableHelperText(adjustmentSettings, 'dateOfSale');

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <Text style={fontStyles.body}>{subtitle}</Text>
      <Text style={fontStyles.h4}>{headerText}</Text>

      <Table>
        <Table.Column>
          <Table.Cell compact />
          <Table.TextCell compact>DOM</Table.TextCell>
          <Table.TextCell compact>Original List Price</Table.TextCell>
          <Table.TextCell compact>Close Price</Table.TextCell>
          <Table.TextCell compact>SP as % LP</Table.TextCell>
        </Table.Column>
        {tableData.map((column) => {
          let compType: CompType | undefined;
          if (column.header !== 'Median') {
            const compNumber = Number(column.header.replace('Comp', '').trim());
            const compId = expected(compSequence[compNumber - 1]);
            compType = compTypes[compId];
          }

          return (
            <Table.Column key={randomUUID()}>
              <Table.CompTypeCell compact compType={compType}>
                {column.header}
              </Table.CompTypeCell>
              <Table.TextCell compact>{column.DOM}</Table.TextCell>
              <Table.TextCell compact>{column.originalListPrice}</Table.TextCell>
              <Table.TextCell compact>{column.closePrice}</Table.TextCell>
              <Table.TextCell compact>{column.salePriceAsPercentageOfListPrice}</Table.TextCell>
            </Table.Column>
          );
        })}
      </Table>

      <Text style={fontStyles.body}>
        List to sale price adjustment: {ratio ? `${ratio}%` : '-'}
      </Text>
      <Text style={fontStyles.small}>{helperText}</Text>
      <CommentarySection title="List to Sale Commentary" commentary={commentary} />
    </Tkv2PDFPage>
  );
};
